<template>
  <div class="financingBaseInfo">

    <table class="con1020 tableCol4">
      <tr>
        <td>
<!--          总金额-->
          {{$t('loan.totalAmount')}}：</td>
        <td>{{data.totalSumUnit}} {{data.totalSum | formatNum}}</td>
        <td>
<!--          定金金额-->
          {{$t('loan.depositAmount')}}：</td>
        <td>{{data.earnestMoneyUnit}} {{data.earnestMoney | formatNum}}</td>
      </tr>
      <tr>
        <td>
<!--          申请金额-->
          {{$t('loan.applyAmount')}}：</td>
        <td>{{data.applyAmountUnit}} {{data.applyAmount | formatNum}}</td>
        <td>
<!--          申请账期-->
          {{$t('loan.applyPaymentDays')}}：</td>
        <td>{{data.applyDate}}</td>
      </tr>

      <tr>
        <td>
<!--          融资用途-->
          {{$t('loan.financingUse')}}：</td>
        <td>{{data.financingPurposes}}</td>
        <td>
<!--          还款来源-->
          {{$t('loan.repaymentSource')}}：</td>
        <td>{{data.repaymentSource}}</td>
      </tr>

      <tr>
        <td>
<!--          担保类型-->
          {{$t('loan.collateralType')}}：</td>
        <td>{{data.typeOfGuarantee}}</td>
        <td>
<!--          代理平台-->
          {{$t('loan.agencyPlat')}}：</td>
        <td>{{data.agentPlatformName}}</td>
      </tr>
      <tr>
        <td>
<!--          融资申请方-->
          {{$t('loan.financingApplicant')}}：</td>
<!--        <td>{{data.applyUserType == 1? $t('loan.buyer') : $t('loan.seller')}}</td>-->
        <td>{{data.applyUserType == 1? data.buyerCompanyName : data.sellerCompanyName}}</td>
        <td></td>
        <td></td>
      </tr>
    </table>
  </div>
</template>
<script>
  export default {
    name: "financingBaseInfo",
    props: ["data"],
    computed: {
    },
    data() {
      return {
        value: ''
      };
    },
    methods: {

    }
  };
</script>

<style lang="scss" scoped>

</style>

